import { CheckCircle2, Clock3 } from "lucide-react";

const Chip = ({ children, tone = "slate", testId }) => {
  const tones = {
    slate: "border-white/10 text-slate-300",
    cyan: "border-cyan-400/40 text-cyan-200",
    amber: "border-amber-400/40 text-amber-200",
    violet: "border-violet-400/40 text-violet-200",
  };
  return <span className={`rounded-full border px-2 py-0.5 text-[10px] font-semibold ${tones[tone]}`} data-testid={testId}>{children}</span>;
};

export const ValidationStatusCard = ({ result }) => {
  const c = result.classification;
  const q = result.quota;
  return (
    <div className="rounded-xl border border-emerald-400/30 bg-emerald-500/5 p-4" role="status" data-testid="validation-status-card">
      <p className="flex items-start gap-2 text-sm font-bold text-emerald-200" data-testid="validation-status-message">
        <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" /> {result.status_message}
      </p>
      <div className="mt-3 flex flex-wrap gap-1.5">
        <Chip tone="cyan" testId="validation-confidence">Confidence {Math.round(c.confidence * 100)}%</Chip>
        <Chip tone={c.source === "ai" ? "violet" : "amber"} testId="validation-source">
          {c.source === "ai" ? `AI classifier · ${c.model_id}` : "Heuristic fallback"}
        </Chip>
        {c.needs_local_catchment && <Chip tone="amber">Local catchment matters</Chip>}
        <Chip testId="validation-evaluation-status"><Clock3 className="mr-1 inline h-3 w-3" aria-hidden="true" />Evaluation {result.evaluation.status}</Chip>
      </div>
      <p className="mt-3 text-xs leading-relaxed text-slate-300" data-testid="validation-reasoning">{c.reasoning}</p>
      <p className="mt-3 text-[11px] text-slate-500" data-testid="validation-quota">
        {q.remaining}/{q.limit} Free Assessment left · job {result.job.id.slice(-6)}
      </p>
      <a href={`/?stage=3&evaluation=${result.evaluation.id}`} className="iv-cta mt-3 inline-flex rounded-full px-4 py-2 text-xs font-bold text-white" data-testid="validation-watch-progress-link">
        Watch live progress & open your 360° Scorecard →
      </a>
    </div>
  );
};
